import React from 'react';
import './App.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faBars} from '@fortawesome/free-solid-svg-icons';
import {faTimes} from '@fortawesome/free-solid-svg-icons';

//import Cheatsheet images
import csI from './img/cheatsheet/wish_I_cs.png';
import csII from './img/cheatsheet/wish_II_cs.png';
import csIII from './img/cheatsheet/wish_III_cs.png';
import csIV from './img/cheatsheet/wish_IV_cs.png';
import csV from './img/cheatsheet/wish_V_cs.png';
import csVI from './img/cheatsheet/wish_VI_cs.png';
import csVII from './img/cheatsheet/wish_VII_cs.png';
import csVIII from './img/cheatsheet/wish_VIII_cs.png';
import csIX from './img/cheatsheet/wish_IX_cs.png';
import csX from './img/cheatsheet/wish_X_cs.png';
import csXI from './img/cheatsheet/wish_XI_cs.png';
import csXII from './img/cheatsheet/wish_XII_cs.png';
import csXIII from './img/cheatsheet/wish_XIII_cs.png';
import csXIV from './img/cheatsheet/wish_XIV_cs.png';
import csXV from './img/cheatsheet/wish_XV_cs.png';

class WishNav extends React.Component{
constructor(props){
  super(props)
  this.state = {active: false, toggleBtn: true};
  
  this.toggleNav = this.toggleNav.bind(this);
}

toggleNav(){
 let currentState = this.state.active;
 this.setState({active: !currentState});

 this.setState(prevState =>({
  toggleBtn: !prevState.toggleBtn
 }));
};


    render(){

        return(
          <div className="navWrapper">
            <aside className={this.state.active ? 'wishNavOpen' : 'wishNavClosed'}>
              <ul>

                {/* Wish I */}
                <li>
                  <div className="wishNum">
                    I.
                  </div>
                  <img src={csI} className="wishImg" alt="wish cheat sheet"/>
                  <hr/>
                </li>

                {/* Wish II */}
                <li>
                  <div className="wishNum">
                    II.
                  </div>
                  <img src={csII} className="wishImg" alt="wish cheat sheet"/>
                  <hr/>
                </li>

                {/* Wish III */}
                <li>
                  <div className="wishNum">
                    III.
                  </div>
                  <img src={csIII} className="wishImg" alt="wish cheat sheet"/>
                  <hr/>
                </li>

                {/* Wish IV */}
                <li>
                <div className="wishNum">
                  IV.
                </div>
                <img src={csIV} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish V */}
            <li>
                <div className="wishNum">
                  V.
                </div>
                <img src={csV} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish VI */}
            <li>
                <div className="wishNum">
                  VI.
                </div>
                <img src={csVI} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish VII */}
            <li>
                <div className="wishNum">
                  VII.
                </div>
                <img src={csVII} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish VIII */}
            <li>
                <div className="wishNum">
                  VIII.
                </div>
                <img src={csVIII} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish IX */}
            <li>
                <div className="wishNum">
                  IX.
                </div>
                <img src={csIX} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish X */}
            <li>
                <div className="wishNum">
                  X.
                </div>
                <img src={csX} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish XI */}
            <li>
                <div className="wishNum">
                  XI.
                </div>
                <img src={csXI} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish XII */}
            <li>
                <div className="wishNum">
                  XII.
                </div>
                <img src={csXII} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish XIII */}
            <li>
                <div className="wishNum">
                  XIII.
                </div>
                <img src={csXIII} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish XIV */}
            <li>
                <div className="wishNum">
                  XIV.
                </div>
                <img src={csXIV} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

            {/* Wish XV */}
            <li>
                <div className="wishNum">
                  XV.
                </div>
                <img src={csXV} className="wishImg" alt="wish cheat sheet"/>
                <hr/>
              </li>

              
              </ul>
          </aside>
         <button className="navBtn" onClick={this.toggleNav}><FontAwesomeIcon icon={this.state.toggleBtn ? faBars : faTimes}/></button>
          </div>
        )
    }
}
export default WishNav;